import { HttpClientModule } from "@angular/common/http";
import { FactoryProvider, NgModule } from '@angular/core';
import { AccountService } from '@services/account.service';
import { CameraCommunicationServer } from '@services/cameraCommunicationServer.service';
import { ChartService } from '@services/charts.service';
import { ColourService } from '@services/colour.service';
import { GoogleService } from '@services/google.service';
import { GoogleMarkerService } from '@services/googleMarker.service';
import { JourneyService } from '@services/journey.service';
import { LoginService } from '@services/login.service.ajs';
import { MapService } from '@services/map.service';
import { NavigationService } from '@services/navigation.service';
import { PlotService } from '@services/plot.service';
import { PlotEventService } from '@services/plotEvent.service';
import { PopupService } from '@services/popup.service';
import { ThemeService } from '@services/theme.service';
import { TranslationService } from '@services/translation.service';
import { TemperatureService } from '@temperature/_services/temperature.service';
import { VehicleDataService } from '../main/components/fleetMaintenance/vehicleData.service';
import { AccountFeatureService } from './accountFeature.service';
import { AvatarService } from './avatar.service';
import { BreadcrumbService } from './breadcrumb.service';
import { CanvasService } from './canvas.service';
import { ConstantsService } from './constantsService';
import { CurrentUserService } from './currentUser.service';
import { DisplayService } from './display.service';
import { DriverService } from './driver.service';
import { DriverAssignmentService } from './driverAssignment.service';
import { FileReaderService } from './fileReader.service';
import { FullScreenService } from './fullscreen.service';
import { GeocodeService } from './geocode.service';
import { GeofenceService } from './geofence.service';
import { GroupService } from './group.service.ajs';
import { HTMLService } from './htmlService.service';
import { MapzenService } from "./mapzen.service";
import { PreferencesService } from './preferences.service';
import { ProductService } from "./product.service";
import { ReasonCodeService } from "./reasonCode.service";
import { SamlService } from "./saml.service";
import { SessionService } from './session.service';
import { TachoService } from './tacho.service';
import { UnitConversionService } from './unitConversion.service';
import { UserMappingsService } from "./userMappings.service";
import { UsersService } from './users.service';
import { UtilisationService } from "./utilisation.service";
import { VehicleService } from './vehicle.service';
import { VeriDate } from './veriDate.service';
import { VeriMarkerService } from './veriMarker.service';
import { VorService } from './vor.service';
import { ThemeServiceNew } from "./theming/theme.service";

export function providerCreator(provide: any, providerString: string): FactoryProvider {

    function serviceFactory(i: angular.Injectable<any>) { return i.get(providerString); }

    return {
        provide: provide,
        useFactory: serviceFactory,
        deps: ['$injector']
    };
}

export function googleMarkerServiceFactory(i: angular.Injectable<any>) { return i.get('googleMarkerService'); }
export const googleMarkerServiceProvider: FactoryProvider = { provide: GoogleMarkerService, useFactory: googleMarkerServiceFactory, deps: ['$injector'] };

export function journeyServiceFactory(i: angular.Injectable<any>) { return i.get('journeyService'); }
export const journeyServiceProvider = { provide: JourneyService, useFactory: journeyServiceFactory, deps: ['$injector'] };

export function colourServiceFactory(i: angular.Injectable<any>) { return i.get('colourService'); }
export const colourServiceProvider = { provide: ColourService, useFactory: colourServiceFactory, deps: ['$injector'] };

export function chartServiceFactory(i: angular.Injectable<any>) { return i.get('chartService'); }
export const chartServiceProvider = { provide: ChartService, useFactory: chartServiceFactory, deps: ['$injector'] };

export function loginServiceFactory(i: angular.Injectable<any>) { return i.get('loginService'); }
export const loginServiceProvider = { provide: LoginService, useFactory: loginServiceFactory, deps: ['$injector'] };

export function accountServiceFactory(i: angular.Injectable<any>) { return i.get('accountService'); }
export const accountServiceProvider = { provide: AccountService, useFactory: accountServiceFactory, deps: ['$injector'] };

export function sessionServiceFactory(i: angular.Injectable<any>) { return i.get('sessionService'); }
export const sessionServiceProvider = { provide: SessionService, useFactory: sessionServiceFactory, deps: ['$injector'] };

export function plotServiceFactory(i: angular.Injectable<any>) { return i.get('plotService'); }
export const plotServiceProvider = { provide: PlotService, useFactory: plotServiceFactory, deps: ['$injector'] };

export function googleServiceFactory(i: angular.Injectable<any>) { return i.get('googleService'); }
export const googleServiceProvider = { provide: GoogleService, useFactory: googleServiceFactory, deps: ['$injector'] };

export function popupServiceFactory(i: angular.Injectable<any>) { return i.get('popupService'); }
export const popupServiceProvider = { provide: PopupService, useFactory: popupServiceFactory, deps: ['$injector'] };

export function mapServiceFactory(i: angular.Injectable<any>) { return i.get('mapService'); }
export const mapServiceProvider = { provide: MapService, useFactory: mapServiceFactory, deps: ['$injector'] };

export function mapzenServiceFactory(i: angular.Injectable<any>) { return i.get('mapzenService'); }
export const mapzenServiceProvider = { provide: MapzenService, useFactory: mapzenServiceFactory, deps: ['$injector'] };

export function vehicleServiceFactory(i: angular.Injectable<any>) { return i.get('vehicleService'); }
export const vehicleServiceProvider = { provide: VehicleService, useFactory: vehicleServiceFactory, deps: ['$injector'] };

export function driverServiceFactory(i: angular.Injectable<any>) { return i.get('driverService'); }
export const driverServiceProvider = { provide: DriverService, useFactory: driverServiceFactory, deps: ['$injector'] };

export function groupServiceFactory(i: angular.Injectable<any>) { return i.get('groupService'); }
export const groupServiceProvider = { provide: GroupService, useFactory: groupServiceFactory, deps: ['$injector'] };

export function tachoServiceFactory(i: angular.Injectable<any>) { return i.get('tachoService'); }
export const tachoServiceProvider = { provide: TachoService, useFactory: tachoServiceFactory, deps: ['$injector'] };

export function vehicleDataFactory(i: angular.Injectable<any>) { return i.get('vehicleDataService'); }
export const vehicleDataServiceProvider = { provide: VehicleDataService, useFactory: vehicleDataFactory, deps: ['$injector'] };

export function veriDateFactory(i: angular.Injectable<any>) { return i.get('veriDate'); }
export const veriDateProvider = { provide: VeriDate, useFactory: veriDateFactory, deps: ['$injector'] };

export function currentUserServiceFactory(i: angular.Injectable<any>) { return i.get('currentUserService'); }
export const currentUserServiceProvider = { provide: CurrentUserService, useFactory: currentUserServiceFactory, deps: ['$injector'] };

export function usersServiceFactory(i: angular.Injectable<any>) { return i.get('usersService'); }
export const usersServiceProvider = { provide: UsersService, useFactory: usersServiceFactory, deps: ['$injector'] };

export function userMappingsServiceFactory(i: angular.Injectable<any>) { return i.get('userMappingsService'); }
export const userMappingsServiceProvider = { provide: UserMappingsService, useFactory: userMappingsServiceFactory, deps: ['$injector'] };

export function accountFeatureServiceFactory(i: angular.Injectable<any>) { return i.get('accountFeatureService'); }
export const accountFeatureServiceProvider = { provide: AccountFeatureService, useFactory: accountFeatureServiceFactory, deps: ['$injector'] };

export function avatarServiceFactory(i: angular.Injectable<any>) { return i.get('avatarService'); }
export const avatarServiceProvider = { provide: AvatarService, useFactory: avatarServiceFactory, deps: ['$injector'] };

export function constantsServiceFactory(i: angular.Injectable<any>) { return i.get('constantsService'); }
export const constantsServiceProvider = { provide: ConstantsService, useFactory: constantsServiceFactory, deps: ['$injector'] };

export function unitConverisonFactory(i: angular.Injectable<any>) { return i.get('unitConversionService'); }
export const unitConversionServiceProvider = { provide: UnitConversionService, useFactory: unitConverisonFactory, deps: ['$injector'] };

export function geofenceServiceFactory(i: angular.Injectable<any>) { return i.get('geofenceService'); }
export const geofenceServiceProvider = { provide: GeofenceService, useFactory: geofenceServiceFactory, deps: ['$injector'] };

export function geocodeServiceFactory(i: angular.Injectable<any>) { return i.get('geocodeService'); }
export const geocodeServiceProvider = { provide: GeocodeService, useFactory: geocodeServiceFactory, deps: ['$injector'] };

export function driverAssignmentServiceFactory(i: angular.Injectable<any>) { return i.get('driverAssignmentService'); }
export const driverAssignmentServiceProvider = { provide: DriverAssignmentService, useFactory: driverAssignmentServiceFactory, deps: ['$injector'] };

export function fullScreenServiceFactory(i: angular.Injectable<any>) { return i.get('fullScreenService'); }
export const fullScreenServiceProvider = { provide: FullScreenService, useFactory: fullScreenServiceFactory, deps: ['$injector'] };

export function canvasServiceFactory(i: angular.Injectable<any>) { return i.get('canvasService'); }
export const canvasServiceProvider = { provide: CanvasService, useFactory: canvasServiceFactory, deps: ['$injector'] };

export function veriMarkerServiceFactory(i: angular.Injectable<any>) { return i.get('veriMarkerService'); }
export const veriMarkerServiceProvider = { provide: VeriMarkerService, useFactory: veriMarkerServiceFactory, deps: ['$injector'] };

export function fileReaderServiceFactory(i: angular.Injectable<any>) { return i.get('fileReaderService'); }
export const fileReaderServiceProvider = { provide: FileReaderService, useFactory: fileReaderServiceFactory, deps: ['$injector'] };

export function displayServiceFactory(i: angular.Injectable<any>) { return i.get('displayService'); }
export const displayServiceProvider = { provide: DisplayService, useFactory: displayServiceFactory, deps: ['$injector'] };

export function translationServiceFactory(i: angular.Injectable<any>) { return i.get('translationService'); }
export const translationServiceProvider = { provide: TranslationService, useFactory: translationServiceFactory, deps: ['$injector'] };

@NgModule({
    imports: [
        HttpClientModule
    ],
    providers: [
        providerCreator(VorService, "vorService"),
        providerCreator(ReasonCodeService, "reasonCodeService"),
        providerCreator(CameraCommunicationServer, "cameraCommunicationServer"),
        providerCreator(ThemeService, "themeService"),
        providerCreator(ThemeServiceNew, "themeServiceNew"),
        providerCreator(HTMLService, "htmlService"),
        providerCreator(PlotEventService, "plotEventService"),
        providerCreator(DisplayService, "displayService"),
        providerCreator(BreadcrumbService, "breadcrumbService"),
        providerCreator(NavigationService, "navigationService"),
        providerCreator(PreferencesService, "preferencesService"),
        providerCreator(TemperatureService, "temperatureService"),
        providerCreator(ProductService, "productService"),
        providerCreator(UtilisationService, "utilisationService"),
        SamlService,
        googleMarkerServiceProvider,
        journeyServiceProvider,
        colourServiceProvider,
        chartServiceProvider,
        loginServiceProvider,
        accountServiceProvider,
        sessionServiceProvider,
        vehicleServiceProvider,
        plotServiceProvider,
        googleServiceProvider,
        mapServiceProvider,
        mapzenServiceProvider,
        popupServiceProvider,
        driverServiceProvider,
        groupServiceProvider,
        tachoServiceProvider,
        vehicleDataServiceProvider,
        veriDateProvider,
        currentUserServiceProvider,
        usersServiceProvider,
        userMappingsServiceProvider,
        accountFeatureServiceProvider,
        avatarServiceProvider,
        constantsServiceProvider,
        unitConversionServiceProvider,
        geofenceServiceProvider,
        geocodeServiceProvider,
        driverAssignmentServiceProvider,
        fullScreenServiceProvider,
        canvasServiceProvider,
        veriMarkerServiceProvider,
        fileReaderServiceProvider,
        translationServiceProvider        
    ]
})
export class ServicesModule {
    constructor() {
    }
}
